import Vue from 'vue/dist/vue.js'

export default Vue.extend({
  data() {
    return {
      happy: false,
      imgForMood: null,
    };
  },
  
  created() {
    this.setHappy(this.params.value === 'T');
  },
  mounted() {
    Vue.nextTick(() => {
      this.$refs.container.focus();
    });
  },
  methods: {
    getValue() {
      return this.happy ? 'T' : 'F';
    },

    isPopup() {
      return true;
    },

    setHappy(happy) {
      this.happy = happy;
    },

    toggleMood() {
      this.setHappy(!this.happy);
    },

    onClick(happy) {
     
      this.toggleMood();
      

      setTimeout(() => this.params.api.stopEditing(), 300);
      
    },

    onKeyDown(event) {
      const key = event.which || event.keyCode;
      if (
        key === 37 || // left
        key === 39
      ) {
        // right
        this.toggleMood();
        event.stopPropagation();
      }
    },
  },
  template: `
        <div :ref="'container'" class="mood" tabindex="0" @keydown="onKeyDown">
            
<div class="toggleWrapper">
<input class="dn" id="dn" type="checkbox" @input="onClick" v-model="happy" />
<label class="toggle" for="dn"><span class="toggle__handler"></span></label>
</div>
        </div>
    `,
});
